export const MODULE = 'auth';

export const login = () => {
    return {
        path: `${MODULE}/login`, method: 'POST', form: `login`
    }
}

export const dasboard = () =>{
    return {
        path: `user/dashboard`, method: 'GET'
    }
}

export const register = () =>{
    return {
        path: `${MODULE}/register`, method: 'POST'
    }
}

export const otpVerify = () =>{
    return {
        path: `front/${MODULE}/otp`, method: 'GET'
    }
}
export const resetPassword = () =>{
    return {
        path: `front/${MODULE}/reset-password`, method: 'GET'
    }
}